export const manipulate_data = (name, status) => {
  var popup_data = require("../data/popup-data.json");
  return popup_data.find((x) => x.name == name)
  .status.find((x) => x.name == status);
};

export default {
    manipulate_data,
};
